import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const ArrowIcon = createIcon({
    viewBox: '0 0 20 20',
    path: <Path fillRule='evenodd' fill='currentColor' d='M10.5 13L16 8H5z' />,
})

ArrowIcon.displayName = 'ArrowIcon'
